// // src/views/BatchMaster/BatchList.jsx
// import React, { useEffect, useState } from 'react';
// import {
//   Card,
//   CardTitle,
//   CardBody,
//   Button,
//   Input,
//   Table,
//   Modal,
//   ModalHeader,
//   ModalBody,
//   ModalFooter,
//   Form,
//   FormGroup,
//   Label,
//   FormText,
//   Row,
//   Col,
// } from 'reactstrap';
// import ReactPaginate from 'react-paginate';
// import { useNavigate } from 'react-router-dom';
// import Select from 'react-select';
// import { apiService } from '../../constants/ApiService';
// import useVendorBranch from '../../utils/useVendorBranch';
// import conditionalDataLoad from '../../utils/conditionalDataLoad';
// import { useSelector } from 'react-redux';
// import VendorBranchSelector from '../../components/VendorBranchSelector';
// import { formatDate } from '../../constants/DateFormatter';
// import { toast } from 'react-toastify';

// const EXAM_SCHEDULE_ROUTE = '/save-batch-exam';

// const pick = (...vals) =>
//   vals.find((v) => v !== undefined && v !== null && v !== '');

// const normalizeCourseStructure = (raw) => {
//   const s = String(raw ?? '')
//     .trim()
//     .toLowerCase();
//   if (!s) return 'semester';
//   if (s.includes('year')) return 'year';
//   if (s.includes('month')) return 'month';
//   if (s.includes('sem')) return 'semester';
//   return 'semester';
// };

// const BatchList = () => {
//   const [errorMessage, setErrorMessage] = useState({});
//   const { user } = useSelector((state) => state.authState);

//   const { isSuperAdmin, isAdmin, hasMultiBranch, hasSingleBranch } =
//     useVendorBranch(user);

//   const [selectionData, setSelectionData] = useState({
//     vendor_id: '',
//     branch_id: '',
//   });

//   const navigate = useNavigate();

//   const [batchList, setBatchList] = useState([]);
//   const [totalPage, setTotalPage] = useState(0);
//   const [search, setSearch] = useState('');

//   // ✅ Filters
//   const [classOptions, setClassOptions] = useState([]); // [{value:id,label:name}]
//   const [selectedClassId, setSelectedClassId] = useState(''); // numeric id string

//   const [sessionOptions, setSessionOptions] = useState([]); // [{value:sessionYear,label:sessionYear}]
//   const [selectedSessionYear, setSelectedSessionYear] = useState(''); // string like "2025-2026"

//   // ✅ BULK IMPORT UI STATE
//   const [showModal, setShowModal] = useState(false);
//   const [file, setFile] = useState(null);
//   const [loading, setLoading] = useState(false);

//   const toggle = () => setShowModal((s) => !s);

//   const openModal = () => {
//     setFile(null);
//     setShowModal(true);
//   };

//   const closeModal = () => {
//     if (!loading) setShowModal(false);
//   };

//   const handleFileChange = (e) => {
//     setFile(e.target.files?.[0] || null);
//   };

//   const handleSubmit = async () => {
//     if (!selectionData.vendor_id || !selectionData.branch_id) {
//       toast.error('Please select Vendor and Branch');
//       return;
//     }

//     if (!file) {
//       toast.error('Please select an Excel (.xlsx) file');
//       return;
//     }

//     if (!file.name.toLowerCase().endsWith('.xlsx')) {
//       toast.error('Only .xlsx files are allowed');
//       return;
//     }

//     const formData = new FormData();
//     formData.append('file', file);

//     try {
//       setLoading(true);

//       const res = await apiService.post(
//         `api/BatchMaster/bulk-import-excel?vendorId=${selectionData.vendor_id}&branchId=${selectionData.branch_id}`,
//         formData,
//         { headers: { 'Content-Type': 'multipart/form-data' } },
//       );

//       if (res?.status) {
//         toast.success(res.message || res.Message || 'Imported successfully');
//         await GetBatchMaster(search, selectedClassId, selectedSessionYear);
//         closeModal();
//       } else {
//         toast.error(res?.message || res?.Message || 'Import failed');
//       }
//     } catch (err) {
//       toast.error(err.response?.data || 'Something went wrong during import');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleDownloadSample = async (e) => {
//     e?.preventDefault?.();
//     try {
//       const response = await apiService.get(
//         '/api/BatchMaster/bulk-import-sample-excel',
//         {
//           responseType: 'blob',
//           headers: { 'Content-Type': undefined },
//         },
//       );

//       const url = window.URL.createObjectURL(new Blob([response.data]));
//       const link = document.createElement('a');
//       link.href = url;
//       link.setAttribute('download', 'batch_master_bulk_import_sample.xlsx');
//       document.body.appendChild(link);
//       link.click();
//       link.remove();
//       window.URL.revokeObjectURL(url);
//     } catch (error) {
//       console.error(error);
//       toast.error('Failed to download sample file');
//     }
//   };

//   // ✅ Add Batch
//   const onHandleAddBatch = () => {
//     navigate('/save-batch');
//   };

//   // ✅ Edit Batch
//   const onHandleEdit = (id) => {
//     const selected = batchList.find((x) => x.id === id);
//     navigate('/save-batch', { state: { ...selected } });
//   };

//   // ✅ Exam Schedule
//   const onHandleExamSchedule = (item) => {
//     const vendorId = selectionData.vendor_id || '';
//     const branchId = selectionData.branch_id || '';

//     if (!vendorId || !branchId) {
//       toast.error('Please select Vendor and Branch');
//       return;
//     }

//     const batch_id = item?.id ?? item?.batch_id ?? item?.ID ?? '';
//     const batch_name = pick(
//       item?.batch_name,
//       item?.BatchName,
//       item?.name,
//       item?.Name,
//       '',
//     );
//     const batch_code = pick(
//       item?.batch_code,
//       item?.BatchCode,
//       item?.code,
//       item?.Code,
//       '',
//     );

//     const class_id = pick(
//       item?.class_id,
//       item?.ClassId,
//       item?.course_id,
//       item?.CourseId,
//       '',
//     );
//     const class_name = pick(
//       item?.class_name,
//       item?.class_Name,
//       item?.class_display_name,
//       item?.course_name,
//       item?.CourseName,
//       item?.Course,
//       '',
//     );

//     const course_structure = normalizeCourseStructure(
//       pick(
//         item?.course_structure,
//         item?.Course_Structure,
//         item?.courseStructure,
//         '',
//       ),
//     );

//     if (!batch_id) {
//       toast.error('Batch not found');
//       return;
//     }
//     if (!class_id) {
//       toast.error('Course/Class not found for this Batch');
//       return;
//     }

//     navigate(EXAM_SCHEDULE_ROUTE, {
//       state: {
//         vendor_id: vendorId,
//         branch_id: branchId,
//         class_id: Number(class_id),
//         class_name: class_name || '',
//         total_semester: 0,
//         course_structure: course_structure || 'semester',
//         batch_id: Number(batch_id),
//         batch_name: batch_name || '',
//         batch_code: batch_code || '',
//         fromBatchList: true,
//       },
//     });
//   };

//   // ✅ Search
//   const onHandleSearch = (e) => {
//     const val = e.target.value;
//     setSearch(val);
//     GetBatchMaster(val, selectedClassId, selectedSessionYear);
//   };

//   // ✅ Class dropdown (id+name)
//   const fetchClasses = async (searchText = '') => {
//     try {
//       const vendorId = selectionData.vendor_id || '';
//       const branchId = selectionData.branch_id || '';
//       // if (!vendorId || !branchId) {
//       //   setClassOptions([]);
//       //   return;
//       // }

//       const res = await apiService.get(
//         `api/ClassMaster/GetClassMaster?vendorId=${vendorId}&branchId=${branchId}&searchItem=${encodeURIComponent(
//           searchText || '',
//         )}`,
//       );

//       if (res?.status === true) {
//         const raw = res?.data || [];
//         const opts = (raw || [])
//           .map((x) => ({
//             value: String(x.id ?? x.ID ?? x.class_id ?? x.classId ?? ''),
//             label: String(
//               x.class_display_name ??
//                 x.class_Name ??
//                 x.className ??
//                 x.name ??
//                 'No Name',
//             ),
//           }))
//           .filter((o) => o.value && o.value !== '0');

//         setClassOptions(opts);
//       } else {
//         setClassOptions([]);
//       }
//     } catch (err) {
//       console.error(err);
//       setClassOptions([]);
//     }
//   };

//   // ✅ Session dropdown
//   // IMPORTANT: We store sessionYear STRING for filtering
//   const fetchSessions = async (searchText = '') => {
//     try {
//       const vendorId = selectionData.vendor_id || '';
//       const branchId = selectionData.branch_id || '';
//       // if (!vendorId || !branchId) {
//       //   setSessionOptions([]);
//       //   return;
//       // }

//       const res = await apiService.get(
//         `api/SessionMaster/GetAllSession?vendorId=${vendorId}&branchId=${branchId}&search=${encodeURIComponent(
//           searchText || '',
//         )}`,
//       );

//       const container = res?.data ?? res;

//       const list =
//         (Array.isArray(container?.data) && container.data) ||
//         (Array.isArray(container?.Data) && container.Data) ||
//         (Array.isArray(container) && container) ||
//         [];

//       const opts = (list || [])
//         .map((x) => {
//           const name =
//             x.session_name ??
//             x.sessionName ??
//             x.session_year ??
//             x.sessionYear ??
//             '';
//           const sessionStr = String(name || '').trim();
//           return sessionStr ? { value: sessionStr, label: sessionStr } : null;
//         })
//         .filter(Boolean);

//       const unique = Array.from(
//         new Map(opts.map((o) => [o.value, o])).values(),
//       );
//       setSessionOptions(unique);
//     } catch (err) {
//       console.error(err);
//       setSessionOptions([]);
//     }
//   };

//   // ✅ API Call (class + sessionYear filters)
//   const GetBatchMaster = async (
//     searchText = '',
//     classId = '',
//     sessionYear = '',
//   ) => {
//     try {
//       const vendorId = selectionData.vendor_id || '';
//       const branchId = selectionData.branch_id || '';

//       // safety
//       if (!vendorId || !branchId) {
//         setBatchList([]);
//         return;
//       }

//       const params = new URLSearchParams();
//       params.append('vendorId', vendorId);
//       params.append('branchId', branchId);
//       params.append('search', searchText || '');

//       // ✅ MUST be numeric ID
//       if (classId) params.append('classId', String(classId));

//       // ✅ IMPORTANT: API param name is sessionYear (NOT session_year)
//       // ✅ and you wanted "last" -> we append it last
//       if (sessionYear) params.append('sessionYear', String(sessionYear));

//       const url = `api/BatchMaster/GetAllBatch?${params.toString()}`;

//       const response = await apiService.get(url);

//       if (response?.status === true) {
//         const list = response?.data || [];
//         setBatchList(Array.isArray(list) ? list : []);
//       } else {
//         toast.error(response?.message || 'Failed to load batches');
//         setBatchList([]);
//       }
//     } catch (error) {
//       console.log(error);
//       toast.error('Something went wrong!!');
//       setBatchList([]);
//     }
//   };

//   const handlePageClick = () => {
//     GetBatchMaster(search, selectedClassId, selectedSessionYear);
//   };

//   // ✅ Auto load on vendor/branch
//   useEffect(() => {
//     const canLoad = conditionalDataLoad({
//       hasMultiBranch,
//       hasSingleBranch,
//       isSuperAdmin,
//       isAdmin,
//       vendorId: selectionData.vendor_id,
//       branchId: selectionData.branch_id,
//     });

//     if (!canLoad) return;

//     // reset filters
//     setSelectedClassId('');
//     setSelectedSessionYear('');
//     setSearch('');

//     fetchClasses('');
//     fetchSessions('');
//     GetBatchMaster('', '', '');
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [selectionData.vendor_id, selectionData.branch_id]);

//   // ✅ Reload list on filter changes (class/session)
//   useEffect(() => {
//     const canLoad = conditionalDataLoad({
//       hasMultiBranch,
//       hasSingleBranch,
//       isSuperAdmin,
//       isAdmin,
//       vendorId: selectionData.vendor_id,
//       branchId: selectionData.branch_id,
//     });
//     if (!canLoad) return;

//     GetBatchMaster(search, selectedClassId, selectedSessionYear);
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [selectedClassId, selectedSessionYear]);

//   return (
//     <>
//       {showModal && (
//         <Modal centered isOpen={showModal} toggle={toggle} size='lg'>
//           <ModalHeader toggle={toggle}>Bulk Import Batches</ModalHeader>

//           <ModalBody>
//             <Form>
//               <FormGroup>
//                 <Label>Upload Excel File</Label>
//                 <Input
//                   type='file'
//                   accept='.xlsx,.xls'
//                   onChange={handleFileChange}
//                 />

//                 <FormText className='text-right'>
//                   <a href='#' onClick={handleDownloadSample}>
//                     <i className='bi bi-download mr-1'></i> Download Excel
//                     Sample format from here
//                   </a>
//                 </FormText>
//               </FormGroup>
//             </Form>
//           </ModalBody>

//           <ModalFooter>
//             <Button color='primary' onClick={handleSubmit} disabled={loading}>
//               {loading ? 'Importing...' : 'Submit'}
//             </Button>
//             <Button color='secondary' onClick={toggle} disabled={loading}>
//               Cancel
//             </Button>
//           </ModalFooter>
//         </Modal>
//       )}

//       <div className='text-right mb-2'>
//         <Button color='success' className='mr-2' onClick={openModal}>
//           <i className='bi bi-file-earmark-spreadsheet mr-1'></i> Bulk Import
//         </Button>

//         <Button color='primary' onClick={onHandleAddBatch}>
//           <i className='bi bi-plus-circle' /> Add Batch
//         </Button>
//       </div>

//       <VendorBranchSelector
//         user={user}
//         selectionData={selectionData}
//         setSelectionData={setSelectionData}
//         errorMessage={errorMessage}
//         accessButton={true}
//       />

//       <Card className='card-box height-100-p pd-20 mb-20'>
//         <CardTitle
//           tag='h6'
//           className='p-3 mb-0 d-flex align-items-center justify-content-between'
//         >
//           <div className='d-flex align-items-center'>
//             <i className='bi bi-mortarboard mr-2'></i> Batch List
//           </div>
//         </CardTitle>

//         {/* ✅ Filters: Search + Class + Session Year */}
//         <div className='p-3'>
//           <Row className='g-2 align-items-end'>
//             <Col md='4'>
//               <Label className='mb-1'>Search</Label>
//               <Input
//                 placeholder='Search...'
//                 value={search}
//                 onChange={onHandleSearch}
//               />
//             </Col>

//             <Col md='4'>
//               <Label className='mb-1'>Class</Label>
//               <Select
//                 options={classOptions}
//                 value={
//                   classOptions.find(
//                     (o) => String(o.value) === String(selectedClassId),
//                   ) || null
//                 }
//                 onChange={(opt) =>
//                   setSelectedClassId(opt ? String(opt.value) : '')
//                 }
//                 onInputChange={(val, meta) => {
//                   if (meta.action === 'input-change') fetchClasses(val);
//                 }}
//                 isClearable
//                 isSearchable
//                 placeholder='All Classes'
//               />
//             </Col>

//             <Col md='4'>
//               <Label className='mb-1'>Session Year</Label>
//               <Select
//                 options={sessionOptions}
//                 value={
//                   sessionOptions.find(
//                     (o) => String(o.value) === String(selectedSessionYear),
//                   ) || null
//                 }
//                 onChange={(opt) =>
//                   setSelectedSessionYear(opt ? String(opt.value) : '')
//                 }
//                 onInputChange={(val, meta) => {
//                   if (meta.action === 'input-change') fetchSessions(val);
//                 }}
//                 isClearable
//                 isSearchable
//                 placeholder='All Sessions'
//               />
//             </Col>
//           </Row>
//         </div>

//         <CardBody>
//           <div className='table-responsive'>
//             <Table hover striped>
//               <thead>
//                 <tr>
//                   <th>#</th>
//                   <th>Edit</th>
//                   <th>Exam Schedule</th>
//                   <th>Course</th>
//                   <th>Batch Name</th>
//                   <th>Batch Code</th>
//                   <th>Timings</th>
//                   <th>Duration</th>
//                 </tr>
//               </thead>

//               <tbody>
//                 {batchList.length > 0 ? (
//                   batchList.map((item, index) => (
//                     <tr key={item.id ?? index}>
//                       <td>{index + 1}</td>

//                       <td>
//                         <i
//                           className='bi bi-pencil text-primary'
//                           style={{ cursor: 'pointer' }}
//                           title='Edit Batch'
//                           onClick={() => onHandleEdit(item.id)}
//                         />
//                       </td>

//                       <td>
//                         <i
//                           className='bi bi-calendar-check text-success'
//                           style={{ cursor: 'pointer', fontSize: '1.1rem' }}
//                           title='Exam Schedule'
//                           onClick={() => onHandleExamSchedule(item)}
//                         />
//                       </td>

//                       <td>{item.class_name}</td>
//                       <td>{item.batch_name}</td>
//                       <td>{item.batch_code}</td>
//                       <td>
//                         {item.batch_start_time} - {item.batch_end_time}
//                       </td>
//                       <td>
//                         {formatDate(item.batch_start_date)} -{' '}
//                         {formatDate(item.batch_end_date)}
//                       </td>
//                     </tr>
//                   ))
//                 ) : (
//                   <tr>
//                     <td colSpan='20' className='text-center'>
//                       No data available
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </Table>
//           </div>
//         </CardBody>

//         <CardBody>
//           <ReactPaginate
//             previousLabel={'Previous'}
//             nextLabel={'Next'}
//             pageCount={totalPage}
//             onPageChange={handlePageClick}
//             containerClassName={'pagination'}
//             activeClassName={'active'}
//           />
//         </CardBody>
//       </Card>
//     </>
//   );
// };

// export default BatchList;
//signalr
// src/views/BatchMaster/BatchList.jsx
import React, { useEffect, useState, useCallback, useRef } from 'react';
import {
  Card,
  CardTitle,
  CardBody,
  Button,
  Input,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  FormText,
  Row,
  Col,
} from 'reactstrap';
import ReactPaginate from 'react-paginate';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import { apiService } from '../../constants/ApiService';
import useVendorBranch from '../../utils/useVendorBranch';
import conditionalDataLoad from '../../utils/conditionalDataLoad';
import { useSelector } from 'react-redux';
import VendorBranchSelector from '../../components/VendorBranchSelector';
import { formatDate } from '../../constants/DateFormatter';
import { toast } from 'react-toastify';
import {
  createAppConnection,
  joinModuleGroup,
  leaveModuleGroup,
  subscribeRealtimeUpdate,
  unsubscribeRealtimeUpdate,
} from '../../utils/signalRService';

const EXAM_SCHEDULE_ROUTE = '/save-batch-exam';
const MODULE_NAME = 'Batch';

const pick = (...vals) =>
  vals.find((v) => v !== undefined && v !== null && v !== '');

const normalizeCourseStructure = (raw) => {
  const s = String(raw ?? '')
    .trim()
    .toLowerCase();

  if (!s) return 'semester';
  if (s.includes('year')) return 'year';
  if (s.includes('month')) return 'month';
  if (s.includes('sem')) return 'semester';

  return 'semester';
};

const BatchList = () => {
  const [errorMessage, setErrorMessage] = useState({});
  const { user } = useSelector((state) => state.authState);
  const navigate = useNavigate();

  const { isSuperAdmin, isAdmin, hasMultiBranch, hasSingleBranch } =
    useVendorBranch(user);

  const [selectionData, setSelectionData] = useState({
    vendor_id: '',
    branch_id: '',
  });

  const [batchList, setBatchList] = useState([]);
  const [totalPage, setTotalPage] = useState(0);
  const [search, setSearch] = useState('');

  // filters
  const [classOptions, setClassOptions] = useState([]);
  const [selectedClassId, setSelectedClassId] = useState('');

  const [sessionOptions, setSessionOptions] = useState([]);
  const [selectedSessionYear, setSelectedSessionYear] = useState('');

  // bulk import
  const [showModal, setShowModal] = useState(false);
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const currentGroupRef = useRef({
    module: null,
    vendorId: null,
    branchId: null,
  });

  const toggle = () => setShowModal((s) => !s);

  const openModal = () => {
    setFile(null);
    setShowModal(true);
  };

  const closeModal = () => {
    if (!loading) setShowModal(false);
  };

  const handleFileChange = (e) => {
    setFile(e.target.files?.[0] || null);
  };

  const onHandleAddBatch = () => {
    navigate('/save-batch');
  };

  const onHandleEdit = (id) => {
    const selected = batchList.find((x) => x.id === id);
    navigate('/save-batch', { state: { ...(selected || {}) } });
  };

  const onHandleExamSchedule = (item) => {
    const vendorId = selectionData.vendor_id || '';
    const branchId = selectionData.branch_id || '';

    // if (!vendorId || !branchId) {
    //   toast.error('Please select Vendor and Branch');
    //   return;
    // }

    const batch_id = item?.id ?? item?.batch_id ?? item?.ID ?? '';
    const batch_name = pick(
      item?.batch_name,
      item?.BatchName,
      item?.name,
      item?.Name,
      '',
    );
    const batch_code = pick(
      item?.batch_code,
      item?.BatchCode,
      item?.code,
      item?.Code,
      '',
    );

    const class_id = pick(
      item?.class_id,
      item?.ClassId,
      item?.course_id,
      item?.CourseId,
      '',
    );
    const class_name = pick(
      item?.class_name,
      item?.class_Name,
      item?.class_display_name,
      item?.course_name,
      item?.CourseName,
      item?.Course,
      '',
    );

    const course_structure = normalizeCourseStructure(
      pick(
        item?.course_structure,
        item?.Course_Structure,
        item?.courseStructure,
        '',
      ),
    );

    if (!batch_id) {
      toast.error('Batch not found');
      return;
    }

    if (!class_id) {
      toast.error('Course/Class not found for this Batch');
      return;
    }

    navigate(EXAM_SCHEDULE_ROUTE, {
      state: {
        vendor_id: vendorId,
        branch_id: branchId,
        class_id: Number(class_id),
        class_name: class_name || '',
        total_semester: 0,
        course_structure: course_structure || 'semester',
        batch_id: Number(batch_id),
        batch_name: batch_name || '',
        batch_code: batch_code || '',
        fromBatchList: true,
      },
    });
  };

  const fetchClasses = async (searchText = '') => {
    try {
      const vendorId = selectionData.vendor_id || '';
      const branchId = selectionData.branch_id || '';

      const res = await apiService.get(
        `api/ClassMaster/GetClassMaster?vendorId=${vendorId}&branchId=${branchId}&searchItem=${encodeURIComponent(
          searchText || '',
        )}`,
      );

      if (res?.status === true) {
        const raw = res?.data || [];
        const opts = (raw || [])
          .map((x) => ({
            value: String(x.id ?? x.ID ?? x.class_id ?? x.classId ?? ''),
            label: String(
              x.class_display_name ??
                x.class_Name ??
                x.className ??
                x.name ??
                'No Name',
            ),
          }))
          .filter((o) => o.value && o.value !== '0');

        setClassOptions(opts);
      } else {
        setClassOptions([]);
      }
    } catch (err) {
      console.error(err);
      setClassOptions([]);
    }
  };

  const fetchSessions = async (searchText = '') => {
    try {
      const vendorId = selectionData.vendor_id || '';
      const branchId = selectionData.branch_id || '';

      const res = await apiService.get(
        `api/SessionMaster/GetAllSession?vendorId=${vendorId}&branchId=${branchId}&search=${encodeURIComponent(
          searchText || '',
        )}`,
      );

      const container = res?.data ?? res;

      const list =
        (Array.isArray(container?.data) && container.data) ||
        (Array.isArray(container?.Data) && container.Data) ||
        (Array.isArray(container) && container) ||
        [];

      const opts = (list || [])
        .map((x) => {
          const name =
            x.session_name ??
            x.sessionName ??
            x.session_year ??
            x.sessionYear ??
            '';

          const sessionStr = String(name || '').trim();
          return sessionStr ? { value: sessionStr, label: sessionStr } : null;
        })
        .filter(Boolean);

      const unique = Array.from(
        new Map(opts.map((o) => [o.value, o])).values(),
      );

      setSessionOptions(unique);
    } catch (err) {
      console.error(err);
      setSessionOptions([]);
    }
  };

  const GetBatchMaster = useCallback(
    async (searchText = '', classId = '', sessionYear = '') => {
      try {
        const vendorId = selectionData.vendor_id || '';
        const branchId = selectionData.branch_id || '';

        // if (!vendorId || !branchId) {
        //   setBatchList([]);
        //   setTotalPage(0);
        //   return;
        // }
      // safety
      // if (!vendorId || !branchId) {
      //   setBatchList([]);
      //   return;
      // }

        const params = new URLSearchParams();
        params.append('vendorId', vendorId);
        params.append('branchId', branchId);
        params.append('search', searchText || '');

        if (classId) params.append('classId', String(classId));
        if (sessionYear) params.append('sessionYear', String(sessionYear));

        const url = `api/BatchMaster/GetAllBatch?${params.toString()}`;
        const response = await apiService.get(url);

        if (response?.status === true) {
          const list = response?.data || [];
          setBatchList(Array.isArray(list) ? list : []);

          const totalPagesValue =
            response?.totalPage ??
            response?.totalPages ??
            response?.pageCount ??
            0;

          setTotalPage(Number(totalPagesValue) || 0);
        } else {
          toast.error(
            response?.message || response?.Message || 'Failed to load batches',
          );
          setBatchList([]);
          setTotalPage(0);
        }
      } catch (error) {
        console.error(error);
        toast.error('Something went wrong!!');
        setBatchList([]);
        setTotalPage(0);
      }
    },
    [selectionData.vendor_id, selectionData.branch_id],
  );

  const onHandleSearch = (e) => {
    const val = e.target.value;
    setSearch(val);
    GetBatchMaster(val, selectedClassId, selectedSessionYear);
  };

  const handlePageClick = () => {
    GetBatchMaster(search, selectedClassId, selectedSessionYear);
  };

  const handleSubmit = async () => {
    if (!selectionData.vendor_id || !selectionData.branch_id) {
      toast.error('Please select Vendor and Branch');
      return;
    }

    if (!file) {
      toast.error('Please select an Excel (.xlsx) file');
      return;
    }

    if (!file.name.toLowerCase().endsWith('.xlsx')) {
      toast.error('Only .xlsx files are allowed');
      return;
    }

    const formData = new FormData();
    formData.append('file', file);

    try {
      setLoading(true);

      const res = await apiService.post(
        `api/BatchMaster/bulk-import-excel?vendorId=${selectionData.vendor_id}&branchId=${selectionData.branch_id}`,
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' } },
      );

      if (res?.status) {
        toast.success(res.message || res.Message || 'Imported successfully');
        await GetBatchMaster(search, selectedClassId, selectedSessionYear);
        closeModal();
      } else {
        toast.error(res?.message || res?.Message || 'Import failed');
      }
    } catch (err) {
      console.error(err);
      toast.error(err.response?.data || 'Something went wrong during import');
    } finally {
      setLoading(false);
    }
  };

  const handleDownloadSample = async (e) => {
    e?.preventDefault?.();

    try {
      const response = await apiService.get(
        '/api/BatchMaster/bulk-import-sample-excel',
        {
          responseType: 'blob',
          headers: { 'Content-Type': undefined },
        },
      );

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'batch_master_bulk_import_sample.xlsx');
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error(error);
      toast.error('Failed to download sample file');
    }
  };

  useEffect(() => {
    const canLoad = conditionalDataLoad({
      hasMultiBranch,
      hasSingleBranch,
      isSuperAdmin,
      isAdmin,
      vendorId: selectionData.vendor_id,
      branchId: selectionData.branch_id,
    });

    if (!canLoad) return;

    setSelectedClassId('');
    setSelectedSessionYear('');
    setSearch('');

    fetchClasses('');
    fetchSessions('');
    GetBatchMaster('', '', '');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectionData.vendor_id, selectionData.branch_id]);

  useEffect(() => {
    const canLoad = conditionalDataLoad({
      hasMultiBranch,
      hasSingleBranch,
      isSuperAdmin,
      isAdmin,
      vendorId: selectionData.vendor_id,
      branchId: selectionData.branch_id,
    });

    if (!canLoad) return;

    GetBatchMaster(search, selectedClassId, selectedSessionYear);
  }, [
    selectedClassId,
    selectedSessionYear,
    hasMultiBranch,
    hasSingleBranch,
    isSuperAdmin,
    isAdmin,
    selectionData.vendor_id,
    selectionData.branch_id,
    GetBatchMaster,
    search,
  ]);

  useEffect(() => {
    let mounted = true;

    const setupSignalR = async () => {
      try {
        await createAppConnection();

        const vendorId = selectionData.vendor_id || 0;
        const branchId = selectionData.branch_id || 0;

        const prev = currentGroupRef.current;

        if (
          prev.vendorId &&
          prev.branchId &&
          (String(prev.vendorId) !== String(vendorId) ||
            String(prev.branchId) !== String(branchId))
        ) {
          await leaveModuleGroup(prev.module, prev.vendorId, prev.branchId);
        }

        if (vendorId && branchId) {
          await joinModuleGroup(MODULE_NAME, vendorId, branchId);

          currentGroupRef.current = {
            module: MODULE_NAME,
            vendorId,
            branchId,
          };
        }

        unsubscribeRealtimeUpdate();

        await subscribeRealtimeUpdate((payload) => {
          if (!mounted) return;
          if (!payload) return;

          const isSameModule = String(payload.module || '') === MODULE_NAME;
          const isSameVendor =
            String(payload.vendorId || '') === String(vendorId || '');
          const isSameBranch =
            String(payload.branchId || '') === String(branchId || '');

          if (isSameModule && isSameVendor && isSameBranch) {
            console.log('Batch realtime update received:', payload);
            GetBatchMaster(search, selectedClassId, selectedSessionYear);
          }
        });
      } catch (err) {
        console.error('SignalR error:', err);
      }
    };

    const canLoad = conditionalDataLoad({
      hasMultiBranch,
      hasSingleBranch,
      isSuperAdmin,
      isAdmin,
      vendorId: selectionData.vendor_id,
      branchId: selectionData.branch_id,
    });

    if (canLoad) {
      setupSignalR();
    }

    return () => {
      mounted = false;
    };
  }, [
    selectionData.vendor_id,
    selectionData.branch_id,
    hasMultiBranch,
    hasSingleBranch,
    isSuperAdmin,
    isAdmin,
    GetBatchMaster,
    search,
    selectedClassId,
    selectedSessionYear,
  ]);

  useEffect(() => {
    return () => {
      unsubscribeRealtimeUpdate();

      const prev = currentGroupRef.current;
      if (prev?.vendorId && prev?.branchId) {
        leaveModuleGroup(prev.module, prev.vendorId, prev.branchId).catch(
          console.error,
        );
      }
    };
  }, []);

  return (
    <>
      {showModal && (
        <Modal centered isOpen={showModal} toggle={toggle} size='lg'>
          <ModalHeader toggle={toggle}>Bulk Import Batches</ModalHeader>

          <ModalBody>
            <Form>
              <FormGroup>
                <Label>Upload Excel File</Label>
                <Input
                  type='file'
                  accept='.xlsx,.xls'
                  onChange={handleFileChange}
                />

                <FormText className='text-right'>
                  <a href='#' onClick={handleDownloadSample}>
                    <i className='bi bi-download mr-1'></i> Download Excel
                    Sample format from here
                  </a>
                </FormText>
              </FormGroup>
            </Form>
          </ModalBody>

          <ModalFooter>
            <Button color='primary' onClick={handleSubmit} disabled={loading}>
              {loading ? 'Importing...' : 'Submit'}
            </Button>
            <Button color='secondary' onClick={toggle} disabled={loading}>
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
      )}

      <div className='text-right mb-2'>
        <Button color='success' className='mr-2' onClick={openModal}>
          <i className='bi bi-file-earmark-spreadsheet mr-1'></i> Bulk Import
        </Button>

        <Button color='primary' onClick={onHandleAddBatch}>
          <i className='bi bi-plus-circle' /> Add Batch
        </Button>
      </div>

      <VendorBranchSelector
        user={user}
        selectionData={selectionData}
        setSelectionData={setSelectionData}
        errorMessage={errorMessage}
        accessButton={true}
      />

      <Card className='card-box height-100-p pd-20 mb-20'>
        <CardTitle
          tag='h6'
          className='p-3 mb-0 d-flex align-items-center justify-content-between'
        >
          <div className='d-flex align-items-center'>
            <i className='bi bi-mortarboard mr-2'></i> Batch List
          </div>
        </CardTitle>

        <div className='p-3'>
          <Row className='g-2 align-items-end'>
            <Col md='4'>
              <Label className='mb-1'>Search</Label>
              <Input
                placeholder='Search...'
                value={search}
                onChange={onHandleSearch}
              />
            </Col>

            <Col md='4'>
              <Label className='mb-1'>Class</Label>
              <Select
                options={classOptions}
                value={
                  classOptions.find(
                    (o) => String(o.value) === String(selectedClassId),
                  ) || null
                }
                onChange={(opt) =>
                  setSelectedClassId(opt ? String(opt.value) : '')
                }
                onInputChange={(val, meta) => {
                  if (meta.action === 'input-change') fetchClasses(val);
                }}
                isClearable
                isSearchable
                placeholder='All Classes'
              />
            </Col>

            <Col md='4'>
              <Label className='mb-1'>Session Year</Label>
              <Select
                options={sessionOptions}
                value={
                  sessionOptions.find(
                    (o) => String(o.value) === String(selectedSessionYear),
                  ) || null
                }
                onChange={(opt) =>
                  setSelectedSessionYear(opt ? String(opt.value) : '')
                }
                onInputChange={(val, meta) => {
                  if (meta.action === 'input-change') fetchSessions(val);
                }}
                isClearable
                isSearchable
                placeholder='All Sessions'
              />
            </Col>
          </Row>
        </div>

        <CardBody>
          <div className='table-responsive'>
            <Table hover striped>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Edit</th>
                  {/* <th>Exam Schedule</th> */}
                  <th>Course</th>
                  <th>Batch Name</th>
                  <th>Batch Code</th>
                  <th>Timings</th>
                  <th>Duration</th>
                </tr>
              </thead>

              <tbody>
                {batchList.length > 0 ? (
                  batchList.map((item, index) => (
                    <tr key={item.id ?? index}>
                      <td>{index + 1}</td>

                      <td>
                        <i
                          className='bi bi-pencil text-primary'
                          style={{ cursor: 'pointer' }}
                          title='Edit Batch'
                          onClick={() => onHandleEdit(item.id)}
                        />
                      </td>

                      {/* <td>
                        <i
                          className='bi bi-calendar-check text-success'
                          style={{ cursor: 'pointer', fontSize: '1.1rem' }}
                          title='Exam Schedule'
                          onClick={() => onHandleExamSchedule(item)}
                        />
                      </td> */}

                      <td>{item.class_name}</td>
                      <td>{item.batch_name}</td>
                      <td>{item.batch_code}</td>
                      <td>
                        {item.batch_start_time} - {item.batch_end_time}
                      </td>
                      <td>
                        {formatDate(item.batch_start_date)} -{' '}
                        {formatDate(item.batch_end_date)}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan='20' className='text-center'>
                      No data available
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </CardBody>

        <CardBody>
          <ReactPaginate
            previousLabel={'Previous'}
            nextLabel={'Next'}
            pageCount={totalPage}
            onPageChange={handlePageClick}
            containerClassName={'pagination'}
            activeClassName={'active'}
          />
        </CardBody>
      </Card>
    </>
  );
};

export default BatchList;
